import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { SpIdSearchFields, SamplingPointsModel, EquipmentModel, AreaModel } from '../../../common/viewModels/GlobalRegistry/SampPointModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../../common/pagerService';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';
import { ValidationService } from '../../../common/validationservice';
import { AmplifyService } from '../../../common/amplify-service';

declare var $: any;
@Component({
    selector: 'equipments',
    templateUrl: './spid.component.html',
    styleUrls: ['./spid.component.scss']
})
export class SpIdComponent implements OnInit {
    spIdForm: FormGroup;
    spIdSearchForm: FormGroup;
    id: number;
    searchFields: SpIdSearchFields = new SpIdSearchFields();
    isNoRecords: boolean = true;
    isSubmitted: boolean = false;
    pager: any = {};
    pagedItems: any[];
    // pageResult: PageResultDto;
    length: number = 0;
    mainComponent: any;
    customers: CustomerModel;
    lstOilGrades: any;
    lstComponents: any;
    lstGraphTemplates: any;
    sampPoints: SamplingPointsModel;
    equipments: EquipmentModel;
    areas: AreaModel;
    constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _validationService: ValidationService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _amplifyService: AmplifyService) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.CreateForm();
        this.spIdSearchForm = this._formBuilder.group({
            SpidNumber: [''],
            CustomerId: [''],
            EquipmentName: [''],
        });
        this.BindStaticSearchData();
        this.GetCustomers();
        this.GetComponents();
        this.GetOilGrades();
        this.GetGraphTemplates();
        this.GetAreas();
        // this.GetEquipments();
        this.GetSamplingPoints();
        this.GetDataFromAmpliy();
        this.setPage(this.pager);
        this.ClearDataInAmplify();
    }

    CreateForm() {

        this.spIdForm = this._formBuilder.group({
            SpidId: [0],
            SpidNumber: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20), Validators.pattern(this._validationService.numberPattern)])],
            CustomerId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            EquipmentName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
            SamplingPointId: [0],
            ComponentId: [0],
            GraphTemplateTypeId: [0],
            OilGradeId: [0],
            AreaId: [0]
        });
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.pageSize;
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetSpIdList(this.pager);
    }

    GetOilGrades() {
        this._http.get(this._appUrl.GetOilGradesForDDL)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstOilGrades = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetComponents() {
        this._http.get(this._appUrl.GetComponentMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstComponents = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetGraphTemplates() {
        this._http.get(this._appUrl.GetGraphTempleteTypeList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstGraphTemplates = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetSamplingPoints() {
        this._http.get(this._appUrl.GetSampPointsMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.sampPoints = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetEquipments() {
        this._http.get(this._appUrl.GetEquipmentMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.equipments = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }
    GetAreas() {
        this._http.get(this._appUrl.GetAreaMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.areas = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetSpIdList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._http.post(this._appUrl.GetSpIdList, this.searchFields)
            .subscribe(
                res => {
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetSpIdById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetSpIdById + id)
            .subscribe(
                m => {
                    this._mApp.HideLoader();
                    if (m.json().Result != null) {
                        this.spIdForm.setValue(m.json().Result);
                    }
                }, error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    DeleteSpId(id: any) {
        this.id = id;
    }


    DeleteSpIdById(id: number) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteSpId + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    this._toastrService.success(res.json().Result, '');
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);

                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSearchSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();
        this.setPage(this.pager);
    }

    ConstructSearchData() {
        let searchDto = this.spIdSearchForm.value;
        if (searchDto.SpidNumber != null)
            this.searchFields.SpidNumber = searchDto.SpidNumber;
        // if (searchDto.CustomerId)
            this.searchFields.CustomerId = searchDto.CustomerId;
        if (searchDto.EquipmentName != null)
            this.searchFields.EquipmentName = searchDto.EquipmentName;
    }

    onSubmit() {
        this.isSubmitted = true;
        if (this.spIdForm.valid) {
            let unitsDto = this.spIdForm.value;
            this._mApp.ShowLoader();
            this._http.post(this._appUrl.UpsertSpId, unitsDto)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '');
                        $('#addSpIdModel').modal('toggle');
                        this.Clear();
                        this.setPage(this.pager);
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '');
                    }
                );
        }
        else {

        }
    }

    Clear() {
        this.spIdForm.reset();
        this.CreateForm();

    }

    OnReset() {
        this.spIdSearchForm.reset();
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.SpidNumber = '';
        this.searchFields.EquipmentName = '';
        this.searchFields.CustomerId = 0;
        this.setPage(this.pager);
    }

    GetMaxSPIDValue() {
        this._http.get(this._appUrl.GetMaxSPIDValue)
            .subscribe(
                data => {
                    if (data.json().Result != null && data.json().Result != "") {
                        var maxNo = Number(data.json().Result);
                        maxNo = maxNo + 1;
                        this.spIdForm.controls['SpidNumber'].setValue(maxNo);
                    }
                },
                error => {
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('eqpmntsList', this.spIdSearchForm.value);
        this._amplifyService.SetStorage('eqpmntsList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('eqpmntsList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('eqpmntsList');
        if (storedData != undefined && storedData != null) {
            this.spIdSearchForm.setValue(storedData);
            this.ConstructSearchData();
        }
        // let savedPageSize = this._amplifyService.GetStorage('eqpmntsList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
        let pageIndex = this._amplifyService.GetStorage('eqpmntsList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('eqpmntsList');
        this._amplifyService.ClearStorage('eqpmntsList_PageNo');
        this._amplifyService.ClearStorage('eqpmntsList_PageSize');
    }
    ExportEquipmentExcel() {
        this._mApp.ShowLoader();
        const searchDto = this.spIdSearchForm.value;
        const excelParams = new SpIdSearchFields();
        excelParams.CustomerId = searchDto.CustomerId;
        excelParams.SpidNumber = searchDto.SpidNumber;
        excelParams.EquipmentName = searchDto.EquipmentName;
        excelParams.IsForExcel = true;
        this._http.post(this._appUrl.ExportEquipmentExcel, excelParams).subscribe(
            (res) => {
            this._mApp.HideLoader();
            window.open(res.json().Result, "_blank");
            excelParams.IsForExcel = false;
            },
            (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, "");
            },
        );
    }
}
